var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('span',{staticClass:"detail-text-label"},[_vm._v(_vm._s(_vm.title))]),_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }